import { useState, useEffect } from 'react';

export interface GlobalSettings {
  enableCopyPreviousWeek: boolean;
  copyDescriptions: boolean;
  copyOnlyBillable: boolean;
  enableAutoSmartFill: boolean;
  enableAiInsights: boolean;
}

/**
 * Hook to access global settings from General Settings
 * In a real application, this would fetch from an API or context
 * For now, we'll use localStorage to simulate persistence
 */
export function useGlobalSettings(): GlobalSettings {
  const [settings, setSettings] = useState<GlobalSettings>({
    enableCopyPreviousWeek: true,
    copyDescriptions: true,
    copyOnlyBillable: false,
    enableAutoSmartFill: true,
    enableAiInsights: true,
  });

  useEffect(() => {
    // Try to load settings from localStorage
    const savedSettings = localStorage.getItem('globalTimesheetSettings');
    if (savedSettings) {
      try {
        const parsed = JSON.parse(savedSettings);
        setSettings({
          enableCopyPreviousWeek: parsed.enableCopyPreviousWeek ?? true,
          copyDescriptions: parsed.copyDescriptions ?? true,
          copyOnlyBillable: parsed.copyOnlyBillable ?? false,
          enableAutoSmartFill: parsed.enableAutoSmartFill ?? true,
          enableAiInsights: parsed.enableAiInsights ?? true,
        });
      } catch (error) {
        console.error('Failed to parse global settings:', error);
      }
    }
  }, []);

  return settings;
}
